import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lacework = defineConnector({
  identifier: "lacework",
  name: "Lacework",
  tagLine: "Cloud security platform",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.lacework\\.net/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.domain}/api/v2/access/tokens`,
        headers: [
          { name: "X-LW-UAKS", value: app.secret.secret },
          {
            name: "content-type",
            value: "application/json",
          },
        ],
        rawBody: `{"keyId":"${app.config.keyId}","expiryTime":86400}`,
      },
      extract: { from: "jsonPath", paths: ["token", "data.token"] },
      apply: { kind: "header", scheme: "Bearer" },
    }),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your Lacework console and navigate to **Settings > API Keys** to generate an API key and secret.",
        },
      ],
    },
    {
      title: "Enter your Lacework details",
      items: [
        {
          kind: "hostname",
          label: "Account hostname",
          required: true,
          placeholder: "yourcompany.lacework.net",
          target: { kind: "configuration", field: "domain" },
          helperText: "Your Lacework account hostname.",
        },
        {
          kind: "input",
          label: "API key ID",
          required: true,
          target: { kind: "configuration", field: "keyId" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "secret" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v2/UserProfile`,
  },
  publicEnvVars: ({ domain }) => ({
    LACEWORK_URL: domain ? `https://${domain}` : "",
  }),
});
